export default function(item, value, fieldKey = null){
    const form = document.getElementById("registration-form");
    const formData = new FormData(form);
    if (item.type === "checkbox") {
        return value === "on";
    }

    if('datetime' === item.type){
        if(value !== ''){
            const date =  new Date(value);
            const year = date.getUTCFullYear();
            const month = String((date.getUTCMonth() + 1)).padStart(2,'0');
            const day = String((date.getUTCDate())).padStart(2,'0');
            const hours = String((date.getUTCHours())).padStart(2,'0');
            const minutes = String((date.getUTCMinutes())).padStart(2,'0');
            const seconds = String((date.getUTCSeconds())).padStart(2,'0');

            return  `${year}-${month}-${day} ${hours}:${minutes}:${seconds}`;
        }
    }
    if (['checkbox_multiple','multiselect'].includes(item.type)) {
        return (
            formData.getAll(fieldKey ? fieldKey : field.key) || null
        );
    }

    return value;
};
